import PropTypes from "prop-types";
import { useToast } from "./ToastProvider";
import Toast from "./Toast";
import { jsx as _jsx } from "react/jsx-runtime";
const ToastContainer = _ref => {
  let {
    dataTestId = "toast-container"
  } = _ref;
  const {
    toasts,
    removeToast
  } = useToast();
  return /*#__PURE__*/_jsx("div", {
    "data-testid": dataTestId,
    className: "fixed z-9999 w-screen max-h-screen overflow-y-hidden flex flex-col items-center gap-y-2.5 pt-10 pointer-events-none",
    children: toasts.map(_ref2 => {
      let {
        id,
        message,
        type,
        dataTestId,
        autoClose,
        className,
        preventCloseOnHover,
        preventAutoClose
      } = _ref2;
      return /*#__PURE__*/_jsx("div", {
        className: "pointer-events-auto w-11/12 h-20",
        children: /*#__PURE__*/_jsx(Toast, {
          id: id,
          message: message,
          type: type,
          dataTestId: dataTestId,
          autoClose: autoClose,
          onClose: removeToast,
          className: className,
          preventCloseOnHover: preventCloseOnHover,
          preventAutoClose: preventAutoClose
        }, id)
      }, id);
    })
  });
};
ToastContainer.propTypes = {
  dataTestId: PropTypes.string
};
export default ToastContainer;
//# sourceMappingURL=ToastContainer.js.map